"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagFJ = function FlagFJ(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.74,12.18H-185.94A7.06,7.06,0,0,1-193,5.12V-114.94a7.06,7.06,0,0,1,7.06-7.06H4.74a7.06,7.06,0,0,1,7.06,7.06V5.12a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.74-122H-7.53L-72.95-79.14V-122h-35.31v42.86L-173.67-122h-12.27a7.06,7.06,0,0,0-7.06,7.06v5.6l56.12,36.77H-193v35.32h56.12L-193-.49V5.12a7.06,7.06,0,0,0,7.06,7.06h12.27l65.42-42.86V12.18h35.3V-30.68L-7.53,12.18H4.74A7.06,7.06,0,0,0,11.8,5.12V-.49L-44.32-37.25H11.8V-72.57H-44.32L11.8-109.34v-5.6A7.06,7.06,0,0,0,4.74-122Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8-65.5H-80V-122h-21.18v56.5H-193v21.18h91.81v56.5H-80v-56.5H11.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-115.32-72.57l-74.31-48.24a7,7,0,0,0-3.37,5.87v.37l64.71,42Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-60-72.57l70.7-45.89a7,7,0,0,0-6-3.54H3.21L-72.95-72.57Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-121.42-37.25-192,8.55a7,7,0,0,0,6,3.63h1.33l76.16-49.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.69,5.67-54.45-37.25h-13L7.68,11.49a7,7,0,0,0,4-5.82Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M64.63-44.93V32.56C64.63,64,108.77,80.14,114.15,82c5.37-1.84,49.52-18,49.52-49.42V-44.93Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M165.42-9.39V-46.68H62.88V-9.39h44.28v35H62.88v14h44.28v42l7,2.33,7-2.33V39.55h44.28v-14H121.14v-35Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M80.21-23.93a5.83,5.83,0,0,1-5.83,5.83,5.83,5.83,0,0,1-5.84-5.83,5.84,5.84,0,0,1,5.84-5.84,5.84,5.84,0,0,1,5.83,5.84Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M85.59-31.82c-1.87-1-5.24-3.78-6.59-3.31s-1.65,1.42-3.55,1.56-4.76,1.95-3.54,3.94c1.58,2.6,6.52.58,6.85-.64a6.65,6.65,0,0,0,2.23,0s2,2.83,4.55,2.64S89.23-31,88.67-31a22.71,22.71,0,0,1-3.08-.84Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M93.33-19.45c-.42.77-3.62,3.5-9,4.76-1.19.28-1,1.68-2.17,1s-4.48-1.26-7.42-1.4A2.82,2.82,0,0,1,72.05-19c.64-1.26,5.33-2,6.17-.48s1.47,1.22,3.56,1.67c1.29.27,1.33.91,1.33.91a15.16,15.16,0,0,1,4.41-3.08c2-.71,3.78-2.24,4.13-2.24a21.51,21.51,0,0,1,2.17.48Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M101.11-27.72c3.07,1.13,12.18.77,21.91-2.37s12.53-3.72,17.29-2,6.82-3.78,3.7-4.71c-4.91-1.47-20.1,7.36-31.1,2.4a3.68,3.68,0,0,0,0,2s-8,.29-6.09-8c0,0,.55,3,4.32,2.67,7.14-.65,8.16,4.37,23.27-.29,8.39-2.58,14.91-1.31,15,2.77.07,4.91-6.7,6.05-6.7,6.05s2.64,5.4,8,3,5.6,1.73,6.06,3.13,1.36,2.76,2.53,2.9c0,0,.84,2.52.51,2.84s-2.52,3.08-4.72,3.08h-6.95s-1.26-3.13,1.17-3.17,5.37-.23,5-1.54S152-20.86,152-22.3c0,0-5.65,4.1-9.14-.75l-.1,2.29s-4.25-.8-5.79-4.2c0,0,.42,3.83-3.22,3.26a7.36,7.36,0,0,0,2,1.92c1.26.79,0,2.52-2.47,4s-9.9,5.65-13.31,1.35.75-6.77,1.78-6.49,4,4.81,6,4.2,3-2.66,1.31-3.92-2.94-2.45-1.88-3.72c1.46-1.75,6.83-1.22,6.64-2.39s-5.18-.84-8.45,2.42-17.46,10.79-23.1,6-1.14-9.39-1.14-9.39Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M99.29-29.81a23.56,23.56,0,0,0,11.48,5.52s-1.33,2-5.18,1.48a11.87,11.87,0,0,1,2.59,3.57,7.3,7.3,0,0,1-4.63-.63,8.85,8.85,0,0,0,1.34,3.29,8.82,8.82,0,0,1-5.33-2.17l-1,2.8a8.82,8.82,0,0,1-2.73-3.29,7.6,7.6,0,0,1-3.93,1.54,14.26,14.26,0,0,0,.7-3.29s-2.8,1.68-5.11,1c0,0,.07-2.94.84-3.78a6.08,6.08,0,0,1-3-.43s.7-1.6,1.05-2.66a4.91,4.91,0,0,1-3.15-1.05s3.78-1.46,4.63-2.87Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffd25a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M92.4-41.58a5.92,5.92,0,0,1,2.75,3.22A6.94,6.94,0,0,1,99.36-41s1.16,1.31.84,4.71c0,0,2.94-.84,4.52.7a7.63,7.63,0,0,0-4.57,3.32s-.56,2.67.42,4.26a4.61,4.61,0,0,1-2.19-.34s-.57,2.66,0,3.5A3.37,3.37,0,0,1,96-26.69s-1.26,1.92-1.16,3.08c0,0-1.69-1-1.78-2.43,0,0-1.16,2.2-2.43,2.39a16.14,16.14,0,0,0-.69-4.25,3.69,3.69,0,0,1-2.48,1.12s0-2.38,1.17-3.5a2.59,2.59,0,0,1-3-1.54s3.21.93,4-1,1-2.56,2.15-3.64.65-5.09.65-5.09Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M99.29-32.54s-4,7.63-7.64,5.32c-4-2.53,1-8.48,1.61-9.1a15,15,0,0,1,6,3.78Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M84.89,6.54S84.47,1.06,81.5-.52C78.71-2,77.06-2.75,76.74-4.66a36.31,36.31,0,0,0,5,1.82c2.32.62,4.58,4.55,3.89,9Zm0,0",
    transform: "translate(194 123)",
    fill: "#5abea0"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M75.51,11.05l.38.7.27,1.49L75.61,15a4.91,4.91,0,0,1,2.68,3.83c.34,2,1.24,2.48,1.79,2.06s.88-.91.31-3.14a18.94,18.94,0,0,0-2.71-5.54L76.13,9.86Zm0,0",
    transform: "translate(194 123)",
    fill: "#b46446"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M77.68,12.23c-2-2.57-7.43-7.94-8.45-.63,0,0-2.13-6.16,1.85-5.92,4.6.28,6.6,6.55,6.6,6.55Zm0,0",
    transform: "translate(194 123)",
    fill: "#5abea0"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M75.89,11.75C74.17,9.86,73.62,8.47,72.73,5S71.56.46,70.53.52s-1.65,1.19-1.65,3.42c0,0-3-2.72-1-4.88s6.66-1,6.94,2.86.2,6.41,1.58,9.62Zm0,0",
    transform: "translate(194 123)",
    fill: "#5abea0"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M76.37,10.07s-3.64-8,6.6-12.33c0,0-9.07-2.44-8,10.45Zm0,0",
    transform: "translate(194 123)",
    fill: "#5abea0"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M77.54,12.93s-7.7-2.93-7,4.18A3.87,3.87,0,0,1,75.61,15Zm0,0",
    transform: "translate(194 123)",
    fill: "#5abea0"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M86.27,10.12c0,2.08.81,8.11-.35,8.87a1.45,1.45,0,0,1-2.1-1.39c.14-1.46.8-8.57.8-10.31s1.65,2.83,1.65,2.83Zm0,0",
    transform: "translate(194 123)",
    fill: "#b46446"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M81.36,15c1.33-1.34,1.75-4.41,1.28-8.5,0,0,2.75,1.91,3.63,3.67,0,0,.87-4-2-5.11s-4.35-.47-4.86.83.87,2.76,1.47,4.88A15.62,15.62,0,0,1,81.36,15Zm0,0",
    transform: "translate(194 123)",
    fill: "#5abea0"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M86.08,9.05a5.13,5.13,0,0,1,2-3s3.12,2.18,2.89,5.11c0,0,.82-4-.87-5.57s-3.62-2-4.58-.61.59,4.09.59,4.09Zm0,0",
    transform: "translate(194 123)",
    fill: "#5abea0"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M86.82,5s1-5.71,3.38-7,6.92-2.42,7.2-2.69c0,0-5.36.27-6.23.27S85.49-.94,85.49,4.22s.46,1.62.59,1.58A5.77,5.77,0,0,0,86.82,5Zm0,0",
    transform: "translate(194 123)",
    fill: "#5abea0"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M89.05,20.07c.55,1.15,1.85,1.43,2.13.84s1.51-5.12,1.51-5.12L90.94,15Zm0,0",
    transform: "translate(194 123)",
    fill: "#b46446"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M99.32,1.06c2.15-1.26,3.57,2.46,3.57,2.46,0-4.38-1.37-5.76-4.8-4.09a5.51,5.51,0,0,0-2.36,2.78C94-2.78,90.16-2.7,90.16-2.7l-.87.6c3.14.6,4.94,4.37,5.7,6.42A23.65,23.65,0,0,0,94.3,8.1C92.24,10.24,90.94,15,90.94,15a8,8,0,0,0,1.75.83s1-3,2.17-2.89,2.6,2,2.64,3.21c0,0,1.79-3.62-.34-5a3.81,3.81,0,0,0-2-.73l1.58-1.78a8.1,8.1,0,0,1,4.36,2.93c.06-4.36-1.87-5.2-3.9-4.84.36-1.75,1.16-5.07,2.08-5.6Zm0,0",
    transform: "translate(194 123)",
    fill: "#5abea0"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M141.73,7.09V19.44c0,.6-2.61,2.92-2.61,2.92h6.95a22.44,22.44,0,0,1-2.23-2.92c0-.33.51-11.42.51-11.42Zm0,0",
    transform: "translate(194 123)",
    fill: "#b46446"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M142.18,8.35c-1.66-.13-6.25,3.65-7.59,9.43,0,0-4.09-6.64,6.12-12.15,0,0-4.53-1.33-11.42,5.84-.37.39-.7-10.82,11.68-7.83,0,0-4.72-6.84-14.42-1.46,0,0,6.45-11.56,16-1.2,0,0,.07-9,.13-8s.76,5.05.76,5.05l1.86-3.25-1.47,6.64s8.49-11.29,15.69.46c0,0-9.31-3.85-13.78.47,0,0,9.58-2.59,8.81,8.5,0,0-3.77-6.58-9.89-5.71,0,0,7.21,3.32,4.91,12.28,0,0-4.34-8.79-7.34-9Zm0,0",
    transform: "translate(194 123)",
    fill: "#5abea0"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M81.25,48.26a1.91,1.91,0,0,0-1.34-.77,3.44,3.44,0,0,0,.27-1.42,2.83,2.83,0,0,0,.44.13l.06-.54A4.66,4.66,0,0,1,78.87,45a2,2,0,0,0-.09-3.06A1.91,1.91,0,0,0,78,43.47a2,2,0,0,0,.48,1.26,8.24,8.24,0,0,1-.71-.56A1.91,1.91,0,0,0,77.2,43a1.94,1.94,0,0,0-1.69-.51,1.93,1.93,0,0,0,.66,1.63,1.9,1.9,0,0,0,1.29.49l.32.26a2,2,0,0,0-1,.11,2,2,0,0,0-1.23,1.26,1.93,1.93,0,0,0,1.75.17,1.9,1.9,0,0,0,1.12-1.06,7.27,7.27,0,0,0,1.22.6h-.07a4,4,0,0,1-.18,1.26A1.92,1.92,0,0,0,77.82,47a2,2,0,0,0-1.31,1.18,1.92,1.92,0,0,0,1.74.28,1.88,1.88,0,0,0,1.07-.82c-.09.27-.21.55-.33.84a1.9,1.9,0,0,0-1,.91,2,2,0,0,0,0,1.76,2,2,0,0,0,1.48-2.47c.05-.12.11-.25.16-.38a2,2,0,0,0,.38.88,1.93,1.93,0,0,0,1.55.83,1.93,1.93,0,0,0-.33-1.73Zm0,0",
    transform: "translate(194 123)",
    fill: "#5abea0"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M78.1,46.54c2.33,0,5.37-.09,5.28,2.24S80.7,59,86.7,61.41s6.72,2.06,6.72,2.06l2.68,6.18,6.54-2.33-6.27-5a17,17,0,0,0-2.06-5.73s3.85-2,5.2-3.67l-2.69-.18A20.09,20.09,0,0,0,101.93,48l-1.88.18a11.06,11.06,0,0,0,2.68-4.65S99.24,47,95.66,47.44c0,0,1.52-3.94,1.88-5.47A33.59,33.59,0,0,1,93,44.39c-1.88.72-4.84.81-3.49,6.9a9.86,9.86,0,0,1-2.6-4.21c-1-2.87-1.34-3.94-2.69-3.94a3.46,3.46,0,0,0-3,2Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffecde"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M144.21,47.69c.81-1.07,2.42-4.43,3.83-3.56s3.3,3,4.44,2,1.2-2.29-.54-2.89-3.7-1.61-4.9-1.21-4.91,4.23-4.91,4.23Zm0,0",
    transform: "translate(194 123)",
    fill: "#b46446"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M133.81,50.58c-.07-1.54,1-8.25,5.17-7.39,2.28.47,3.41,2.89,6.38,4,3.16,1.21,5.17,2,4.57,4s-1.75,4.57-4.37,5.17-11.75-5.84-11.75-5.84Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M131.05,56.11c-.89.18-4.21,5-.26,9.94,0,0,4.83,2,8.68-1.08s1-4.56,1-4.56Zm0,0",
    transform: "translate(194 123)",
    fill: "#5abea0"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M131.39,57.16a1.68,1.68,0,0,1-.34-1s-.2-6.94,2.69-7.07S147,55.75,147,56.89s-3.36,4.43-6.18,5.11-9.47-4.84-9.47-4.84Zm0,0",
    transform: "translate(194 123)",
    fill: "#5abea0"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M124.27,74s9.18-4.12,7.45-7.47c-1.24-2.42-4-.87-4.48,1a27.72,27.72,0,0,1-3,6.5Zm0,0",
    transform: "translate(194 123)",
    fill: "#b46446"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M114.15,85.66l-.53-.16A117.66,117.66,0,0,1,87.55,72.76C70.27,61.37,61.13,47.47,61.13,32.56v-81h106v81c0,14.91-9.13,28.81-26.41,40.2A117.66,117.66,0,0,1,114.68,85.5ZM64.63-44.93V32.56C64.63,64,108.77,80.14,114.15,82c5.37-1.84,49.52-18,49.52-49.42V-44.93Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagFJ;
exports["default"] = _default;